// extracted by mini-css-extract-plugin
var _1 = "RentalPortalApplicantsTableLayout-modulepageActions__H6QrA PageActions-modulePageActions__lL8Sl";
var _2 = "RentalPortalApplicantsTableLayout-modulepaginationSkeleton__D8UE5 Skeleton-moduleSkeleton__Mlrfv";
export { _1 as "pageActions", _2 as "paginationSkeleton" }
